import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { apiSlice } from './api/apiSlice'
import authReducer from './slices/authSlice'
import uiReducer from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    api: apiSlice.reducer,
    auth: authReducer,
    ui: uiReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          // Ignore Keycloak-related actions that might contain non-serializable data
          'auth/setKeycloakInstance',
          'auth/setUser',
        ],
        ignoredPaths: [
          // Ignore Keycloak instance in state
          'auth.keycloakInstance',
        ],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.DEV,
})

// Enable listener behavior for the store
setupListeners(store.dispatch)

// Export types for TypeScript
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Export hooks for use in components
export { useAppDispatch, useAppSelector } from './hooks'
